import {Box, Menu, MenuItem, Toolbar, Typography, useTheme} from "@mui/material"
import {useState} from "react"
import {motion} from 'framer-motion';
import SettingsIcon from "@mui/icons-material/Settings";
import {useLocation, useNavigate} from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import {AccountCircle} from "@mui/icons-material";
import SummarizeIcon from "@mui/icons-material/Summarize";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import GroupIcon from "@mui/icons-material/Group";


const TopToolbar = () => {
    const theme = useTheme()
    const navigate = useNavigate();
    const location = useLocation();
    const [asiaUser,setAsiaUser] = useState(localStorage.getItem("asiaUser"));
    const [anchorEl, setAnchorEl] = useState(null)

    const barHeight = theme.mixins.toolbar.minHeight
    const open = Boolean(anchorEl)
    const menuItems = [
        {
            label: 'Home',
            path: '',
            icon: <HomeIcon/>
        },
        {
            label: 'My profile',
            path: 'profile',
            icon: <AccountCircle/>
        },
        {
            label: 'Reports',
            path: 'reports',
            icon: <SummarizeIcon/>
        },

    ]
    const menuPopoverItems = [
        {
            label: 'Tags',
            path: 'tags',
            icon: <LocalOfferIcon/>
        } ,{
            label: 'Users',
            path: 'users',
            icon: <GroupIcon/>
        },
    ]

    const handleConfigClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        localStorage.removeItem('asiaUser')
        setAsiaUser(null)
        localStorage.removeItem('asiaUserToken')
        navigate('/login')
    }

    return (
        <Toolbar
            sx={{
                boxShadow: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: barHeight,
                px: 2,
                bgcolor: 'background.paper',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img src="/assets/ASIA_Logo_Modificato.png" alt="Asia logo" style={{ height: 60,marginTop:12 }} />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {menuItems.map((item, index) => {
                    const isActive = '/' + item.path === location.pathname;

                    return (
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            key={index}
                            onClick={() => navigate(item.path)}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    cursor: 'pointer',
                                    px: 2,
                                    py: 1,
                                    borderRadius: 2,
                                    backgroundColor: isActive ? '#5cbec4' : 'transparent',
                                    color: isActive ? '#1A1A1A' : 'text.primary',
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        backgroundColor: isActive ? '#96c9cd' : 'grey.100',
                                    },
                                }}
                            >
                                {item.icon && (
                                    <Box sx={{ color: 'inherit', display: 'flex' }}>
                                        {item.icon}
                                    </Box>
                                )}
                                <Typography variant="subtitle2" sx={{ fontWeight: 500, color: 'inherit' }}>
                                    {item.label}
                                </Typography>
                            </Box>
                        </motion.div>
                    );
                })}

                <Box>
                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={handleConfigClick}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                px: 2,
                                py: 1,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': { backgroundColor: 'grey.100' },
                            }}
                        >
                            <SettingsIcon />
                            <Typography variant="subtitle2" sx={{ fontWeight: 500, ml: 1 }}>
                                Config
                            </Typography>
                        </Box>
                    </motion.div>

                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        PaperProps={{
                            sx: {
                                mt: 1,
                                zIndex: 1300,
                                borderRadius: 2,
                                minWidth: 160,
                                boxShadow: 3,
                            },
                        }}
                    >
                        {menuPopoverItems.map((item, i) => {
                            const isActive = '/' + item.path === location.pathname;

                            return (
                                <MenuItem
                                    key={i}
                                    onClick={() => {
                                        navigate(item.path);
                                        handleClose();
                                    }}
                                    sx={{
                                        px: 3,
                                        py: 1.5,
                                        borderRadius: 2,
                                        my: 0.5,
                                        fontWeight: 500,
                                        fontSize: '0.95rem',
                                        backgroundColor: isActive ? '#5cbec4' : 'transparent',
                                        color: isActive ? '#1A1A1A' : 'text.primary',
                                        '&:hover': {
                                            backgroundColor: isActive ? '#96c9cd' : 'grey.100',
                                        },
                                        transition: 'all 0.2s ease-in-out',
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {item.icon}
                                        {item.label}
                                    </Box>
                                </MenuItem>
                            );
                        })}
                    </Menu>
                </Box>

                <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => {
                        if(asiaUser) {
                            logout()
                        } else {
                            navigate('/login')
                        }
                    }}
                >
                    {asiaUser ?
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 2,
                            py: 1,
                            borderRadius: 2,
                            backgroundColor: '#FFE6E6',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': { backgroundColor: '#FFCCCC' },
                        }}
                    >
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'red' }}>
                            Logout
                        </Typography>
                    </Box>
                     : <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                px: 2,
                                py: 1,
                                borderRadius: 2,
                                backgroundColor: '#d6d6d6',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': { backgroundColor: '#d8d8d8' },
                            }}
                        >
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'blue' }}>
                                Login
                            </Typography>
                        </Box>}
                </motion.div>
            </Box>
        </Toolbar>

    );
};

export default TopToolbar;
